import { getEnvironment } from '@sail/utils';
import { DEFAULT_LOCALE, DEFAULT_LOCALE_DATA } from '../internal/constants';
import { IntlMissingLocaleData } from '../internal/errors';
export default function getLocaleData(requestedLocale, config, reports) {
    const { localeData } = config;
    if (requestedLocale === DEFAULT_LOCALE) {
        return DEFAULT_LOCALE_DATA;
    }
    if (!localeData || (localeData === null || localeData === void 0 ? void 0 : localeData.locale) !== requestedLocale) {
        const error = new IntlMissingLocaleData(requestedLocale);
        reports.error(error, {
            project: 'sail_core'
        });
        if (getEnvironment() !== 'production') {
            throw error;
        }
        return DEFAULT_LOCALE_DATA;
    }
    return localeData;
}

//# sourceMappingURL=getLocaleData.js.map